import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import CountryModalContainer from '../../components/SetupSubPageComps/CountriesComps/CountryModalContainer';
import ShowAllCountries from '../../components/SetupSubPageComps/CountriesComps/ShowAllCountries';
import CountryProvider from '../../contexts/CountryProvider';

const Countries = () => {
  // rendering countries page component here
  return (
    <>
      <PageTitle title='Countries' />

      <CountryProvider>
        <ShowAllCountries />
        <CountryModalContainer />
      </CountryProvider>
    </>
  );
};

export default Countries;
